"use strict";

var _defineProperty = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _inherits = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var conversions = require("webidl-conversions");

var utils = require("./utils.js");

var EventHandlerNonNull = require("./EventHandlerNonNull.js");

var OnErrorEventHandlerNonNull = require("./OnErrorEventHandlerNonNull.js");

var ceReactionsPreSteps_helpers_custom_elements = require("../helpers/custom-elements.js").ceReactionsPreSteps;

var ceReactionsPostSteps_helpers_custom_elements = require("../helpers/custom-elements.js").ceReactionsPostSteps;

var implSymbol = utils.implSymbol;
var ctorRegistrySymbol = utils.ctorRegistrySymbol;

var Element = require("./Element.js");

var interfaceName = "SVGElement";

exports.is = function (value) {
  return utils.isObject(value) && utils.hasOwn(value, implSymbol) && value[implSymbol] instanceof Impl.implementation;
};

exports.isImpl = function (value) {
  return utils.isObject(value) && value instanceof Impl.implementation;
};

exports.convert = function (value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? "The provided value" : _ref$context;

  if (exports.is(value)) {
    return utils.implForWrapper(value);
  }

  throw new TypeError("".concat(context, " is not of type 'SVGElement'."));
};

function makeWrapper(globalObject) {
  if (globalObject[ctorRegistrySymbol] === undefined) {
    throw new Error("Internal error: invalid global object");
  }

  var ctor = globalObject[ctorRegistrySymbol]["SVGElement"];

  if (ctor === undefined) {
    throw new Error("Internal error: constructor SVGElement is not installed on the passed global object");
  }

  return Object.create(ctor.prototype);
}

exports.create = function (globalObject, constructorArgs, privateData) {
  var wrapper = makeWrapper(globalObject);
  return exports.setup(wrapper, globalObject, constructorArgs, privateData);
};

exports.createImpl = function (globalObject, constructorArgs, privateData) {
  var wrapper = exports.create(globalObject, constructorArgs, privateData);
  return utils.implForWrapper(wrapper);
};

exports._internalSetup = function (wrapper, globalObject) {
  Element._internalSetup(wrapper, globalObject);
};

exports.setup = function (wrapper, globalObject) {
  var constructorArgs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var privateData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  privateData.wrapper = wrapper;

  exports._internalSetup(wrapper, globalObject);

  Object.defineProperty(wrapper, implSymbol, {
    value: new Impl.implementation(globalObject, constructorArgs, privateData),
    configurable: true
  });
  wrapper[implSymbol][utils.wrapperSymbol] = wrapper;

  if (Impl.init) {
    Impl.init(wrapper[implSymbol]);
  }

  return wrapper;
};

exports.new = function (globalObject) {
  var wrapper = makeWrapper(globalObject);

  exports._internalSetup(wrapper, globalObject);

  Object.defineProperty(wrapper, implSymbol, {
    value: Object.create(Impl.implementation.prototype),
    configurable: true
  });
  wrapper[implSymbol][utils.wrapperSymbol] = wrapper;

  if (Impl.init) {
    Impl.init(wrapper[implSymbol]);
  }

  return wrapper[implSymbol];
};

var exposed = new Set(["Window"]);

exports.install = function (globalObject, globalNames) {
  if (!globalNames.some(function (globalName) {
    return exposed.has(globalName);
  })) {
    return;
  }

  if (globalObject.Element === undefined) {
    throw new Error("Internal error: attempting to evaluate SVGElement before Element");
  }

  var SVGElement =
  /*#__PURE__*/
  function (_globalObject$Element) {
    _inherits(SVGElement, _globalObject$Element);

    function SVGElement() {
      var _this;

      _classCallCheck(this, SVGElement);

      throw new TypeError("Illegal constructor");
      return _possibleConstructorReturn(_this);
    }

    _createClass(SVGElement, [{
      key: "focus",
      value: function focus() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'focus' called on an object that is not a valid instance of SVGElement.");
        }

        return esValue[implSymbol].focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'blur' called on an object that is not a valid instance of SVGElement.");
        }

        return esValue[implSymbol].blur();
      }
    }, {
      key: "className",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get className' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.getSameObject(this, "className", function () {
          return utils.tryWrapperForImpl(esValue[implSymbol]["className"]);
        });
      }
    }, {
      key: "ownerSVGElement",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get ownerSVGElement' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["ownerSVGElement"]);
      }
    }, {
      key: "viewportElement",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get viewportElement' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["viewportElement"]);
      }
    }, {
      key: "style",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get style' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.getSameObject(this, "style", function () {
          return utils.tryWrapperForImpl(esValue[implSymbol]["style"]);
        });
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set style' called on an object that is not a valid instance of SVGElement.");
        }

        var Q = esValue["style"];

        if (!utils.isObject(Q)) {
          throw new TypeError("Property 'style' is not an object");
        }

        Reflect.set(Q, "cssText", V);
      }
    }, {
      key: "onabort",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onabort' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onabort"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onabort' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onabort' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onabort"] = V;
      }
    }, {
      key: "onauxclick",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onauxclick' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onauxclick"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onauxclick' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onauxclick' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onauxclick"] = V;
      }
    }, {
      key: "onblur",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onblur' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onblur"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onblur' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onblur' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onblur"] = V;
      }
    }, {
      key: "oncancel",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get oncancel' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["oncancel"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set oncancel' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'oncancel' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["oncancel"] = V;
      }
    }, {
      key: "oncanplay",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get oncanplay' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["oncanplay"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set oncanplay' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'oncanplay' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["oncanplay"] = V;
      }
    }, {
      key: "oncanplaythrough",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get oncanplaythrough' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["oncanplaythrough"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set oncanplaythrough' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'oncanplaythrough' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["oncanplaythrough"] = V;
      }
    }, {
      key: "onchange",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onchange' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onchange"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onchange' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onchange' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onchange"] = V;
      }
    }, {
      key: "onclick",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onclick' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onclick"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onclick' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onclick' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onclick"] = V;
      }
    }, {
      key: "onclose",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onclose' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onclose"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onclose' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onclose' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onclose"] = V;
      }
    }, {
      key: "oncontextmenu",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get oncontextmenu' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["oncontextmenu"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set oncontextmenu' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'oncontextmenu' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["oncontextmenu"] = V;
      }
    }, {
      key: "oncuechange",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get oncuechange' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["oncuechange"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set oncuechange' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'oncuechange' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["oncuechange"] = V;
      }
    }, {
      key: "ondblclick",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get ondblclick' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["ondblclick"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set ondblclick' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'ondblclick' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["ondblclick"] = V;
      }
    }, {
      key: "ondrag",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get ondrag' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["ondrag"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set ondrag' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'ondrag' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["ondrag"] = V;
      }
    }, {
      key: "ondragend",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get ondragend' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["ondragend"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set ondragend' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'ondragend' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["ondragend"] = V;
      }
    }, {
      key: "ondragenter",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get ondragenter' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["ondragenter"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set ondragenter' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'ondragenter' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["ondragenter"] = V;
      }
    }, {
      key: "ondragleave",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get ondragleave' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["ondragleave"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set ondragleave' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'ondragleave' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["ondragleave"] = V;
      }
    }, {
      key: "ondragover",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get ondragover' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["ondragover"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set ondragover' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'ondragover' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["ondragover"] = V;
      }
    }, {
      key: "ondragstart",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get ondragstart' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["ondragstart"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set ondragstart' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'ondragstart' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["ondragstart"] = V;
      }
    }, {
      key: "ondrop",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get ondrop' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["ondrop"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set ondrop' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'ondrop' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["ondrop"] = V;
      }
    }, {
      key: "ondurationchange",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get ondurationchange' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["ondurationchange"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set ondurationchange' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'ondurationchange' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["ondurationchange"] = V;
      }
    }, {
      key: "onemptied",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onemptied' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onemptied"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onemptied' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onemptied' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onemptied"] = V;
      }
    }, {
      key: "onended",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onended' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onended"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onended' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onended' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onended"] = V;
      }
    }, {
      key: "onerror",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onerror' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onerror"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onerror' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = OnErrorEventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onerror' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onerror"] = V;
      }
    }, {
      key: "onfocus",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onfocus' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onfocus"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onfocus' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onfocus' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onfocus"] = V;
      }
    }, {
      key: "oninput",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get oninput' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["oninput"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set oninput' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'oninput' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["oninput"] = V;
      }
    }, {
      key: "oninvalid",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get oninvalid' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["oninvalid"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set oninvalid' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'oninvalid' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["oninvalid"] = V;
      }
    }, {
      key: "onkeydown",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onkeydown' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onkeydown"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onkeydown' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onkeydown' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onkeydown"] = V;
      }
    }, {
      key: "onkeypress",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onkeypress' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onkeypress"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onkeypress' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onkeypress' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onkeypress"] = V;
      }
    }, {
      key: "onkeyup",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onkeyup' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onkeyup"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onkeyup' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onkeyup' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onkeyup"] = V;
      }
    }, {
      key: "onload",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onload' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onload"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onload' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onload' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onload"] = V;
      }
    }, {
      key: "onloadeddata",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onloadeddata' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onloadeddata"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onloadeddata' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onloadeddata' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onloadeddata"] = V;
      }
    }, {
      key: "onloadedmetadata",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onloadedmetadata' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onloadedmetadata"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onloadedmetadata' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onloadedmetadata' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onloadedmetadata"] = V;
      }
    }, {
      key: "onloadend",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onloadend' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onloadend"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onloadend' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onloadend' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onloadend"] = V;
      }
    }, {
      key: "onloadstart",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onloadstart' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onloadstart"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onloadstart' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onloadstart' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onloadstart"] = V;
      }
    }, {
      key: "onmousedown",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onmousedown' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onmousedown"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onmousedown' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onmousedown' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onmousedown"] = V;
      }
    }, {
      key: "onmouseenter",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          return;
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onmouseenter"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          return;
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onmouseenter' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onmouseenter"] = V;
      }
    }, {
      key: "onmouseleave",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          return;
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onmouseleave"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          return;
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onmouseleave' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onmouseleave"] = V;
      }
    }, {
      key: "onmousemove",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onmousemove' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onmousemove"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onmousemove' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onmousemove' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onmousemove"] = V;
      }
    }, {
      key: "onmouseout",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onmouseout' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onmouseout"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onmouseout' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onmouseout' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onmouseout"] = V;
      }
    }, {
      key: "onmouseover",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onmouseover' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onmouseover"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onmouseover' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onmouseover' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onmouseover"] = V;
      }
    }, {
      key: "onmouseup",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onmouseup' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onmouseup"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onmouseup' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onmouseup' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onmouseup"] = V;
      }
    }, {
      key: "onwheel",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onwheel' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onwheel"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onwheel' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onwheel' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onwheel"] = V;
      }
    }, {
      key: "onpause",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onpause' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onpause"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onpause' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onpause' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onpause"] = V;
      }
    }, {
      key: "onplay",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onplay' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onplay"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onplay' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onplay' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onplay"] = V;
      }
    }, {
      key: "onplaying",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onplaying' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onplaying"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onplaying' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onplaying' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onplaying"] = V;
      }
    }, {
      key: "onprogress",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onprogress' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onprogress"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onprogress' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onprogress' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onprogress"] = V;
      }
    }, {
      key: "onratechange",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onratechange' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onratechange"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onratechange' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onratechange' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onratechange"] = V;
      }
    }, {
      key: "onreset",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onreset' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onreset"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onreset' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onreset' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onreset"] = V;
      }
    }, {
      key: "onresize",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onresize' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onresize"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onresize' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onresize' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onresize"] = V;
      }
    }, {
      key: "onscroll",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onscroll' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onscroll"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onscroll' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onscroll' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onscroll"] = V;
      }
    }, {
      key: "onsecuritypolicyviolation",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onsecuritypolicyviolation' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onsecuritypolicyviolation"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onsecuritypolicyviolation' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onsecuritypolicyviolation' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onsecuritypolicyviolation"] = V;
      }
    }, {
      key: "onseeked",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onseeked' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onseeked"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onseeked' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onseeked' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onseeked"] = V;
      }
    }, {
      key: "onseeking",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onseeking' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onseeking"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onseeking' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onseeking' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onseeking"] = V;
      }
    }, {
      key: "onselect",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onselect' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onselect"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onselect' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onselect' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onselect"] = V;
      }
    }, {
      key: "onstalled",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onstalled' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onstalled"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onstalled' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onstalled' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onstalled"] = V;
      }
    }, {
      key: "onsubmit",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onsubmit' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onsubmit"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onsubmit' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onsubmit' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onsubmit"] = V;
      }
    }, {
      key: "onsuspend",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onsuspend' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onsuspend"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onsuspend' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onsuspend' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onsuspend"] = V;
      }
    }, {
      key: "ontimeupdate",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get ontimeupdate' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["ontimeupdate"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set ontimeupdate' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'ontimeupdate' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["ontimeupdate"] = V;
      }
    }, {
      key: "ontoggle",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get ontoggle' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["ontoggle"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set ontoggle' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'ontoggle' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["ontoggle"] = V;
      }
    }, {
      key: "onvolumechange",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onvolumechange' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onvolumechange"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onvolumechange' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onvolumechange' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onvolumechange"] = V;
      }
    }, {
      key: "onwaiting",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get onwaiting' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.tryWrapperForImpl(esValue[implSymbol]["onwaiting"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set onwaiting' called on an object that is not a valid instance of SVGElement.");
        }

        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(V, {
            context: "Failed to set the 'onwaiting' property on 'SVGElement': The provided value"
          });
        }

        esValue[implSymbol]["onwaiting"] = V;
      }
    }, {
      key: "dataset",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get dataset' called on an object that is not a valid instance of SVGElement.");
        }

        return utils.getSameObject(this, "dataset", function () {
          return utils.tryWrapperForImpl(esValue[implSymbol]["dataset"]);
        });
      }
    }, {
      key: "nonce",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get nonce' called on an object that is not a valid instance of SVGElement.");
        }

        var value = esValue[implSymbol].getAttributeNS(null, "nonce");
        return value === null ? "" : value;
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set nonce' called on an object that is not a valid instance of SVGElement.");
        }

        V = conversions["DOMString"](V, {
          context: "Failed to set the 'nonce' property on 'SVGElement': The provided value"
        });
        esValue[implSymbol].setAttributeNS(null, "nonce", V);
      }
    }, {
      key: "tabIndex",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'get tabIndex' called on an object that is not a valid instance of SVGElement.");
        }

        ceReactionsPreSteps_helpers_custom_elements(globalObject);

        try {
          return esValue[implSymbol]["tabIndex"];
        } finally {
          ceReactionsPostSteps_helpers_custom_elements(globalObject);
        }
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;

        if (!exports.is(esValue)) {
          throw new TypeError("'set tabIndex' called on an object that is not a valid instance of SVGElement.");
        }

        V = conversions["long"](V, {
          context: "Failed to set the 'tabIndex' property on 'SVGElement': The provided value"
        });
        ceReactionsPreSteps_helpers_custom_elements(globalObject);

        try {
          esValue[implSymbol]["tabIndex"] = V;
        } finally {
          ceReactionsPostSteps_helpers_custom_elements(globalObject);
        }
      }
    }]);

    return SVGElement;
  }(globalObject.Element);

  Object.defineProperties(SVGElement.prototype, _defineProperty({
    focus: {
      enumerable: true
    },
    blur: {
      enumerable: true
    },
    className: {
      enumerable: true
    },
    ownerSVGElement: {
      enumerable: true
    },
    viewportElement: {
      enumerable: true
    },
    style: {
      enumerable: true
    },
    onabort: {
      enumerable: true
    },
    onauxclick: {
      enumerable: true
    },
    onblur: {
      enumerable: true
    },
    oncancel: {
      enumerable: true
    },
    oncanplay: {
      enumerable: true
    },
    oncanplaythrough: {
      enumerable: true
    },
    onchange: {
      enumerable: true
    },
    onclick: {
      enumerable: true
    },
    onclose: {
      enumerable: true
    },
    oncontextmenu: {
      enumerable: true
    },
    oncuechange: {
      enumerable: true
    },
    ondblclick: {
      enumerable: true
    },
    ondrag: {
      enumerable: true
    },
    ondragend: {
      enumerable: true
    },
    ondragenter: {
      enumerable: true
    },
    ondragleave: {
      enumerable: true
    },
    ondragover: {
      enumerable: true
    },
    ondragstart: {
      enumerable: true
    },
    ondrop: {
      enumerable: true
    },
    ondurationchange: {
      enumerable: true
    },
    onemptied: {
      enumerable: true
    },
    onended: {
      enumerable: true
    },
    onerror: {
      enumerable: true
    },
    onfocus: {
      enumerable: true
    },
    oninput: {
      enumerable: true
    },
    oninvalid: {
      enumerable: true
    },
    onkeydown: {
      enumerable: true
    },
    onkeypress: {
      enumerable: true
    },
    onkeyup: {
      enumerable: true
    },
    onload: {
      enumerable: true
    },
    onloadeddata: {
      enumerable: true
    },
    onloadedmetadata: {
      enumerable: true
    },
    onloadend: {
      enumerable: true
    },
    onloadstart: {
      enumerable: true
    },
    onmousedown: {
      enumerable: true
    },
    onmouseenter: {
      enumerable: true
    },
    onmouseleave: {
      enumerable: true
    },
    onmousemove: {
      enumerable: true
    },
    onmouseout: {
      enumerable: true
    },
    onmouseover: {
      enumerable: true
    },
    onmouseup: {
      enumerable: true
    },
    onwheel: {
      enumerable: true
    },
    onpause: {
      enumerable: true
    },
    onplay: {
      enumerable: true
    },
    onplaying: {
      enumerable: true
    },
    onprogress: {
      enumerable: true
    },
    onratechange: {
      enumerable: true
    },
    onreset: {
      enumerable: true
    },
    onresize: {
      enumerable: true
    },
    onscroll: {
      enumerable: true
    },
    onsecuritypolicyviolation: {
      enumerable: true
    },
    onseeked: {
      enumerable: true
    },
    onseeking: {
      enumerable: true
    },
    onselect: {
      enumerable: true
    },
    onstalled: {
      enumerable: true
    },
    onsubmit: {
      enumerable: true
    },
    onsuspend: {
      enumerable: true
    },
    ontimeupdate: {
      enumerable: true
    },
    ontoggle: {
      enumerable: true
    },
    onvolumechange: {
      enumerable: true
    },
    onwaiting: {
      enumerable: true
    },
    dataset: {
      enumerable: true
    },
    nonce: {
      enumerable: true
    },
    tabIndex: {
      enumerable: true
    }
  }, Symbol.toStringTag, {
    value: "SVGElement",
    configurable: true
  }));

  if (globalObject[ctorRegistrySymbol] === undefined) {
    globalObject[ctorRegistrySymbol] = Object.create(null);
  }

  globalObject[ctorRegistrySymbol][interfaceName] = SVGElement;
  Object.defineProperty(globalObject, interfaceName, {
    configurable: true,
    writable: true,
    value: SVGElement
  });
};

var Impl = require("../nodes/SVGElement-impl.js");